/** @format */

import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { axios } from "axios";
import { alertMsg } from "../utilities/helper";
import { url } from "./api";
import { delOne, getAll, getOne } from "./helper";
import { jwt } from "./api";
import {
  getClientOrders,
  getAllClients,
  getClient,
  deleteClient,
  updateClient,
} from "../services/clintServices";
import { preparePaginationData } from "../constant/common";

const initialState = {
  id: null,
  render: false,
  allClients: {},
  client: {},
  success: "",
  error: "",
  loading: false,
  clientOrders: [],
};

const client = createSlice({
  name: "clients",
  initialState,
  reducers: {
    setClientID(state, action) {
      state.id = action.payload.id;
    },
    deleteClientRTK(state) {
      let allClientsClone = { ...state.allClients };
      allClientsClone.data = allClientsClone.data.filter(
        (item) => item.id !== state.id
      );
      state.allClients = allClientsClone;
    },
    baneClientAction(state) {
      let allClientsClone = { ...state.allClients };
      let clientIndex = allClientsClone.data.findIndex(
        (client) => client.d === state.id
      );
      allClientsClone.data[clientIndex].status = "banned";
      state.allClients = allClientsClone;
    },
  },
  extraReducers: (builder) => {
    //get all clients
    //pending
    builder.addCase(getAllClients.pending, (state, action) => {
      state.loading = true;
    });
    //success
    builder.addCase(getAllClients.fulfilled, (state, action) => {
      state.loading = false;
      let data = preparePaginationData(action.payload.data);
      state.allClients = data;
      state.success = action.payload.data.status;
    });
    //reject
    builder.addCase(getAllClients.rejected, (state, action) => {
      state.loading = false;
    });

    //get one client
    //pending
    builder.addCase(getClient.pending, (state, action) => {
      state.loading = true;
    });
    //success
    builder.addCase(getClient.fulfilled, (state, action) => {
      state.loading = false;
      state.client = action.payload.data;
      state.success = action.payload.data.status;
    });
    //reject
    builder.addCase(getClient.rejected, (state, action) => {
      state.loading = false;
    });
    //get one client orders
    //pending
    builder.addCase(getClientOrders.pending, (state, action) => {
      state.loading = true;
    });
    //success
    builder.addCase(getClientOrders.fulfilled, (state, action) => {
      state.loading = false;
      state.clientOrders = action.payload.data;
      state.success = action.payload.data.status;
    });
    //reject
    builder.addCase(getClientOrders.rejected, (state, action) => {
      state.loading = false;
    });

    //delete one client
    //pending
    builder.addCase(deleteClient.pending, (state, action) => {
      state.loading = true;
    });
    //success
    builder.addCase(deleteClient.fulfilled, (state, action) => {
      state.loading = false;
      state.success = action.payload.status;
    });
    //reject
    builder.addCase(deleteClient.rejected, (state, action) => {
      state.loading = false;
    });

    //update client
    builder.addCase(updateClient.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(updateClient.fulfilled, (state, action) => {
      state.loading = false;
      state.success = action.payload.status;
    });
    builder.addCase(updateClient.rejected, (state, action) => {
      state.loading = false;
    });
  },
});

export default client.reducer;
export const { setClientID, deleteClientRTK, baneClientAction } =
  client.actions;
